import { useTranslation } from 'react-i18next';
import { POSITION_DETAILS_TABS } from '../../../consts';
import { PERMISSIONS, PERMISSIONS_GROUPS } from '../../../consts/permissions';
import { useAuth } from '../../../hooks/useAuth';
import STRING_KEYS from '../../../language/keys';
import { TabsNavigation } from '../../TabsNavigation';
// import { style } from './style';

type PositionTabsProps = {
  currentTab: string,
  onNavigateClick: (tab: string) => void,
}

export const PositionTabs = ({
  currentTab,
  onNavigateClick,
}: PositionTabsProps):JSX.Element => {
  const { t: translate } = useTranslation();
  const { hasPermissions } = useAuth();

  const tabArr = [
    {
      value: POSITION_DETAILS_TABS.APP,
      label: translate(STRING_KEYS.APP_MATCHES),
      permissions: PERMISSIONS_GROUPS.POSITION_MATCHES_TAB,
    },
    {
      value: POSITION_DETAILS_TABS.RESULTS,
      label: translate(STRING_KEYS.MATCH_RESULT),
      permissions: [PERMISSIONS.MATCH_CANDIDATE_VIEW],
    },
    {
      value: POSITION_DETAILS_TABS.RUNS,
      label: translate(STRING_KEYS.MATCH_ENGINE),
      permissions: [PERMISSIONS.MATCH_CANDIDATE_VIEW],
    },
  ].filter((tab) => {
    return !tab.permissions || hasPermissions(tab.permissions);
  });

  return (
    <TabsNavigation
      onNavigateClick={ onNavigateClick }
      tabArr={ tabArr }
      currentTab={ currentTab }
    />
  );
};
